import { Typography } from "@mui/material";
import React from "react";
import styles from "./Declaration.module.css";

function Declaration() {
  return (
    <div className={styles.declaration}>
      <Typography>
        I/We hereby authorize you to debit my/our account and credit my/our home
        loan account within 30 days of the mortgage being registered or upon
        drawdown as per the limit approved. I/We authorize you to increase the
        monthly installment in the event of an increase in the interest rate.
        I/We confirm that the information supplied in the application form is
        true and correct, and that you may use such information to assess the
        loan application. Materially incorrect information could lead to this
        loan facility being withdrawn and intentional or negligent disclosure
        may lead to possible criminal liability.
      </Typography>
      <Typography>
        In the event that I request you to send me a statement or other
        information by email, I/we agree to indemnify you against any claim or
        liability that may arise or be made by any person (including myself)
        against it in consequence of the supply of such information by email.
        Searches and valuation assessments of properties undertaken by us are to
        ascertain whether the land and improvements to it have sufficient
        apparent value for the property to act as a security for the loan
        granted and also assess the replacement value of improvements for
        insurance purposes. Such searches and valuation assessments are for our
        internal purposes only and no warranties whatsoever in respect of the
        property, its title, condition, the purchase price or the insurance
        amount are given or implied in the granting of the loan. The cost of
        such searches will be for your account. You accept no liability for any
        defects whether latent or patent in the property or the sum insured,
        being either land or improvements as a result of assessment of the
        property by you. Where concerns regarding the property exist, it is
        my/our responsibility to seek appropriate independent expert advice. The
        property will at all times be insured at the replacement cost on Stanbic
        IBTC Bank PLC terms and through an insurer on your approved list for the
        amount stated.
      </Typography>
      <Typography>
        I/We understand that if a loan is granted to me/us by you, all costs,
        and fees in connection with insurance and the drawing up and
        registration of a mortgage will be for my/our own account. You are
        authorized but not obliged to act on instructions transmitted by me/us
        through a facsimile or email, unless advised to the contrary by me/us.
        In the event of late/returned payments, the Bank reserves the right to
        charge overdue interest or penalties as determined by the Bank. You are
        authorized to verify any information given on this application form, and
        generally make whatever enquiries are necessary from any source
        whatsoever. In the event that I/we request the bank to send me/us a bank
        statement or any other information by any means, I/we agree to indemnify
        you against any claim/s or liability that may arise or be made by any
        person (including myself/ourselves) against it in consequence of the
        supply of such information by the requested means.
      </Typography>
    </div>
  );
}

export default Declaration;
